<div class="topic-container" [ngStyle]="containerBoxStyle">
  <div class="left">
    <a [ngStyle]="titleStyle" [routerLink]="topicUrl">{{ topic.title }}</a>
    <div class="post-detail">
      {{ topic.createdAt | timeAgo }}
    </div>
  </div>

  <div class="post-amount-comment">
    <i class="material-icons">mode_comment</i>{{ topic.numberOfComments }}
  </div>
</div>
